import { render } from "./Menuitem.vue?vue&type=template&id=11a77dea"
import script from "./Menuitem.vue?vue&type=script&lang=js"
export * from "./Menuitem.vue?vue&type=script&lang=js"
script.render = render

export default script